import { useEffect } from "react";

type TProps = {
  setIsClicked: (isClicked: boolean) => void;
  isClicked: boolean;
  shouldBeClickableElementId: string | string[];
};

const useOutsideClickHandler = ({
  setIsClicked,
  isClicked,
  shouldBeClickableElementId,
}: TProps) => {
  useEffect(() => {
    if (!isClicked) return;

    const handleClick = (event: MouseEvent) => {
      let isInside = false;

      if (typeof shouldBeClickableElementId === "string") {
        const el = document.getElementById(shouldBeClickableElementId);
        if (el && el.contains(event.target as Node)) {
          isInside = true;
        }
      } else if (Array.isArray(shouldBeClickableElementId)) {
        for (const id of shouldBeClickableElementId) {
          const el = document.getElementById(id);
          if (el && el.contains(event.target as Node)) {
            isInside = true;
            break;
          }
        }
      }

      if (!isInside) {
        setIsClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [isClicked, shouldBeClickableElementId, setIsClicked]);
};

export default useOutsideClickHandler;
